import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { Observable, map, startWith, timer } from 'rxjs';

@Component({
  selector: 'app-message-carousel',
  templateUrl: './message-carousel.component.html',
  styleUrls: ['./message-carousel.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class MessageCarouselComponent implements OnInit {
  @Input() messageKeys: string[] = [];
  @Input() timeInterval = 3000;

  public currentMessage$?: Observable<string>;

  ngOnInit() {
    this.currentMessage$ = timer(0, this.timeInterval).pipe(
      map((index) => this.messageKeys[index % this.messageKeys.length]),
      startWith(this.messageKeys[0]),
    );
  }
}
